module.exports = __webpack_public_path__ + "img/LIVEPEN.c9a2f1ff.png";